import type { ActionBinding } from "../ActionBinding.type"
import createActionBinding from "../createActionBinding"
import createGamepadBinding from "../createGamepadBinding"
import createKeyboardBinding from "../createKeyboardBinding"
import createMouseClickBinding from "../createMouseClickBinding"
import { InputActionType } from "../InputActionType"
import { InputProfilePresetId } from "../InputProfilePreset/InputProfilePresetId.enum"
import { MouseButton } from "../MouseButton.enum"

export function getInputProfilePreset(presetId: InputProfilePresetId): ActionBinding[] {
  switch (presetId) {
    case InputProfilePresetId.ClassicKeyboard:
      return getClassicKeyboardPreset()
    case InputProfilePresetId.GridKeysKeyboard:
      return getGridKeysKeyboardPreset()
    case InputProfilePresetId.ModernKeyboard:
      return getModernKeyboardPreset()
    case InputProfilePresetId.DefaultGamepad:
      return getDefaultGamepadPreset()
    default:
      return []
  }
}

function getClassicKeyboardPreset(): ActionBinding[] {
  // Based on createDefaultActionBindings - this is the classic preset
  const SHIFT = true
  return [
    createActionBinding(InputActionType.Escape, createKeyboardBinding("Escape")),
    createActionBinding(InputActionType.Delete, createKeyboardBinding("Delete")),
    createActionBinding(InputActionType.Duplicate, createKeyboardBinding("KeyD")),
    createActionBinding(InputActionType.RotateClockwise, createKeyboardBinding("KeyR")),
    createActionBinding(InputActionType.EndTurn, createKeyboardBinding("Enter", SHIFT)),
    createActionBinding(InputActionType.StartTurn, createKeyboardBinding("Enter")),
    createActionBinding(InputActionType.Primary, createMouseClickBinding(MouseButton.PRIMARY)),
    createActionBinding(InputActionType.Primary, createKeyboardBinding("Enter")),
  ]
}

function getGridKeysKeyboardPreset(): ActionBinding[] {
  // Placeholder - inherits from classic for now
  return getClassicKeyboardPreset()
}

function getModernKeyboardPreset(): ActionBinding[] {
  // Placeholder - inherits from classic for now
  return getClassicKeyboardPreset()
}

function getDefaultGamepadPreset(): ActionBinding[] {
  // Default gamepad bindings
  return [
    createActionBinding(InputActionType.Escape, createGamepadBinding(9)), // Start button
    createActionBinding(InputActionType.Primary, createGamepadBinding(0)), // A button
    createActionBinding(InputActionType.Secondary, createGamepadBinding(1)), // B button
    createActionBinding(InputActionType.RotateClockwise, createGamepadBinding(2)), // X button
    createActionBinding(InputActionType.Delete, createGamepadBinding(3)), // Y button
  ]
}

